"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
  id: "_Symbols",
  "data-name": "Symbols"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Header-ATC-view-Searching"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Fill-1",
  d: "M18.06 10.64v1.3h5.59v5.19H8.91L11 15l-.92-.92-2.63 2.66a1.42 1.42 0 0 0-.4 1 1.39 1.39 0 0 0 .4 1l2.66 2.65.92-.92-2-2H24.3a.65.65 0 0 0 .65-.65v-6.53a.65.65 0 0 0-.65-.65z"
})))));
module.exports = exports.default;